import { TBustSize } from "../../types/user";
import { TTypeInput } from "../ui/Input/Input";

export const BUST_SIZE: { id: number; name: TBustSize }[] = [
  {
    id: 1,
    name: "A",
  },
  {
    id: 2,
    name: "B",
  },
  {
    id: 3,
    name: "C",
  },
  {
    id: 4,
    name: "D",
  },
  {
    id: 5,
    name: "F",
  },
];

export type TypeIdGeneral =
  | "firstname"
  | "lastname"
  | "userName"
  | "gender"
  | "lang"
  | "email"
  | "password"
  | "date"
  | "tel"
  | "city"
  | "code"
  | "club";

type InputGeneralBase = {
  id: TypeIdGeneral | TypeIdParametrs;
  label: string;
  placeholder: string;
};

type InputGeneralSelectMulti = InputGeneralBase & {
  type: "selectMulti";
  value: number[];
  options: Array<{ id: number; name: string }>;
};

type InputGeneralSelect = InputGeneralBase & {
  type: "select";
  value: number;
  options: Array<{ id: number; name: string }>;
};

type InputGeneralNumber = InputGeneralBase & {
  type: "number";
  value: number | null;
};

type InputGeneralString = InputGeneralBase & {
  type: Exclude<
    TTypeInput | "password" | "textarea",
    "select" | "number" | "selectMulti"
  >;
  value: string;
};

export type IInputGeneral =
  | InputGeneralSelect
  | InputGeneralNumber
  | InputGeneralString
  | InputGeneralSelectMulti;

export const inputGeneral: IInputGeneral[] = [
  {
    id: "firstname",
    type: "text",
    label: "FirstName",
    value: "",
    placeholder: "John",
  },
  {
    id: "lastname",
    type: "text",
    label: "LastName",
    value: "",
    placeholder: "Doe",
  },
  {
    id: "gender",
    type: "select",
    label: "Gender",
    value: 0,
    options: [
      { id: 1, name: "Male" },
      { id: 2, name: "Female" },
    ],
    placeholder: "Select gender",
  },
  {
    id: "lang",
    type: "selectMulti",
    label: "Language",
    value: [],
    options: [],
    placeholder: "Select language",
  },
  {
    id: "email",
    type: "email",
    label: "Email",
    value: "",
    placeholder: "example@mail.com",
  },
  {
    id: "password",
    type: "password",
    label: "Passwort",
    value: "",
    placeholder: "Enter password",
  },
  {
    id: "date",
    type: "date",
    label: "Geburtsdatum",
    value: "",
    placeholder: "DD.MM.YYYY",
  },
  {
    id: "tel",
    type: "tel",
    label: "Telefonnummer",
    value: "",
    placeholder: "Enter phone number",
  },
  {
    id: "city",
    type: "text",
    label: "Stadt",
    value: "",
    placeholder: "Enter city",
  },
  {
    id: "code",
    type: "number",
    label: "Postleitzahl",
    value: null,
    placeholder: "Enter postal code",
  },
  {
    id: "club",
    type: "selectMulti",
    label: "Klub",
    value: [],
    options: [],
    placeholder: "Select club",
  },
];

export type TypeIdParametrs =
  | "height"
  | "weight"
  | "brust"
  | "appearance"
  | "description"
  | "haircut";

export const inputParameters: IInputGeneral[] = [
  {
    id: "height",
    type: "number",
    label: "Größe",
    value: null,
    placeholder: "Enter größe",
  },
  {
    id: "weight",
    type: "number",
    label: "Gewicht",
    value: null,
    placeholder: "Enter gewicht",
  },
  {
    id: "brust",
    type: "select",
    label: "Brust",
    value: 0,
    options: BUST_SIZE,
    placeholder: "Enter value",
  },
  {
    id: "appearance",
    type: "selectMulti",
    label: "Aussehen",
    value: [],
    options: [],
    placeholder: "Select appearance",
  },
  {
    id: "haircut",
    type: "select",
    label: "Intimer Haarschnitt",
    value: 0,
    options: [],
    placeholder: "Select intimate haircut",
  },
  {
    id: "description",
    type: "textarea",
    label: "Intimer Haarschnitt",
    value: "",
    placeholder: "Select intimate haircut",
  },
];

export const GENDER_NUMBERS = {
  M: 1,
  F: 2,
};
